import React, { useRef } from "react";
import { CardWithLable, Input, Button, DropDown } from "@public/ui-toolkit";
import ReactDropDown from "@public/ui-toolkit/src/ReactSelect";

const Search = ({
  headTitle,
  cardSpacing,
  handleSearch,
  strategyFilter,
  aumFilter,
  regionFilter,
  subSpecialtyFilter,
  dropDownData,
  onSubmit,
  onChangeStrategy,
  onChangeAum,
  subSpecialtyDropDown,
  onChangeSubSpecialty,
  onChangeRegion,
  onKeyPress,
  regionDropDownData,
  aumData,
  showDropDown,
  title,
}) => {
  const searchEl = useRef(null);
  const customStyles = {
    control: (provided, state) =>
    ({
      ...provided,
      // width: "120px",
      overflow : "visible",
      backgroundColor: "#3ac1b5",
      border: '#3ac1b5',
      padding: 4,
    }),
    menu:base =>({...base,position:"absolute",overflow : "visible",}),
    menuPortal: base => ({ ...base, zIndex: 9999 ,overflow : "visible",}),
    option: (base, state) =>
    ({
      ...base,
      height: '100%',
      fontSize: "12px"
    }),
    dropdownIndicator: base => ({
      ...base,
      overflow : "visible",
      color: "#fff"
    }),
    singleValue: (provided) => ({ ...provided, color: "#fff" }),
    input: (styles) => ({ ...styles, color: "#fff", fontSize: "12px" })
  };
  return (
    <CardWithLable
      title={title}
      img="./assets/images/drag-icon.svg"
      alt="drag icon"
      cardSpacing={cardSpacing}
    >
      <div className="hf-card2-body">
        <form onSubmit={onSubmit} onKeyPress={onKeyPress}>
          <div className="row g-3 mb-2">
            <div className="col-md-8">
              <Input
                type="search"
                id="search"
                placeholder="Search"
                label="Search"
                forr="search"
                inputRef={searchEl}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <Button type="submit" btnName="Search" btnType="!primary" />
            </div>
          </div>
          <div className="row g-3">
            {showDropDown === false ? (
              ""
            ) : (
              <div className="col-md-6">
                <ReactDropDown
                  styles={customStyles}
                  selectedValue={strategyFilter > 0 ? { value: strategyFilter, label: dropDownData.filter((s) => s.id === parseInt(strategyFilter))[0]?.name } : { value: "Strategies", label: "Strategies" }}
                  onChange={onChangeStrategy}
                  performanceMetrcisResult={dropDownData?.map((item) => ({ value: item.id, label: item.name, isdisabled: item.isExistFund }))}
                />
              </div>
            )}
             {showDropDown === false ? (
              ""
            ) : (
              <div className="col-md-6">
                <ReactDropDown
                  styles={customStyles}
                  selectedValue={subSpecialtyFilter > 0 ? { value: subSpecialtyFilter, label: subSpecialtyDropDown.filter((s) => s.id === parseInt(subSpecialtyFilter))[0]?.name } : { value: "Sub-Strategy", label: "Sub-Strategy" }}
                  onChange={onChangeSubSpecialty}
                  performanceMetrcisResult={subSpecialtyDropDown?.map((item) => ({ value: item.id, label: item.name, isdisabled: item.isExistFund }))}
                />
              </div>
            )}
            {showDropDown === false ? (
              ""
            ) : (
              <div className="col-md-6">
                <ReactDropDown
                  styles={customStyles}
                  selectedValue={aumFilter ? { value: aumFilter, label: aumFilter } : { value: "AUM", label: "AUM" }}
                  onChange={onChangeAum}
                  performanceMetrcisResult={aumData?.map((item) => ({ value: item.value, label: item.option }))}
                />
              </div>
            )}
            {showDropDown === false ? (
              ""
            ) : (
              <div className="col-md-6">
                <ReactDropDown
                  styles={customStyles}
                  selectedValue={regionFilter ? { value: regionFilter, label: regionDropDownData.filter((s) => s.id === parseInt(regionFilter))[0]?.name } : { value: "Region", label: "Region" }}
                  onChange={onChangeRegion}
                  performanceMetrcisResult={regionDropDownData?.map((item) => ({ value: item.id, label: item.name }))}
                />
              </div>
            )}
           
          </div>
        </form>
      </div>
    </CardWithLable>
  );
};

export default Search;
